import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  hasOngoingTrainings: true,
};

const trainingSlice = createSlice({
  name: "trainingStatus",
  initialState,
  reducers: {
    setOngoingTrainings: (state: any, action: PayloadAction<any>) => {
      state.hasOngoingTrainings = action.payload;
    },
  },
});

export const { setOngoingTrainings } = trainingSlice.actions;
export default trainingSlice.reducer;